<template>
  <div>
    <div class="form-group">
      <label class="col-form-label col-lg-2">Category Budgets Enabled </label>
      <switches
        v-model="childCategoryBudgetsEnabled"
        type-bold="false"
        color="primary"
        class="ml-1 mb-0 mt-2"
      ></switches>
    </div>
    <div v-if="!childCategoryBudgetsEnabled" class="col-lg-4">
      <b-form-group
        label="Budget"
        label-for="budget"
        :invalid-feedback="invalidFeedbackBudget"
        :state="childJobBudget ? jobBudgetValid : null"
      >
        <b-form-input
          id="budget"
          v-model="childJobBudget"
          :state="childJobBudget ? jobBudgetValid : null"
          @keypress="currencyAutoFormatter($event, childJobBudget)"
          @input="jobBudgetUpdated"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        v-if="childJobBudgetInitial && childJobBudget !== childJobBudgetInitial"
        label="Reason for Budget Revision"
        label-for="revisionDescription"
        :state="revisionDescription ? true : null"
      >
        <b-form-input
          id="revisionDescription"
          v-model="revisionDescription"
          :state="revisionDescription ? true : null"
        ></b-form-input>
      </b-form-group>
    </div>
    <table
      v-if="childCategoryBudgetsEnabled"
      class="table table-centered table-nowrap"
    >
      <thead class="thead-light" style="text-align:center">
        <tr>
          <th style="width: 20px;">Enabled</th>
          <th>Name</th>
          <th>Type</th>
          <th>Unit of Measure</th>
          <th>Budget</th>
        </tr>
      </thead>
      <tbody style="text-align:center">
        <tr v-for="(control, index) in controls" :key="control.name">
          <td>
            <div
              v-if="control.type"
              :id="`checkbox-${index}`"
              style="display: inline-block;"
            >
              <b-form-checkbox v-model="control.active"> </b-form-checkbox>
            </div>
          </td>
          <td>
            <a class="text-body font-weight-bold no-pointer">{{
              control.name
            }}</a>
          </td>
          <td style="width:30%; text-align: left">
            <b-form-group>
              <b-form-radio
                v-for="(type, typeIndex) in control.types"
                :key="typeIndex"
                v-model="control.type"
                :name="`type_${control.name}`"
                :value="type"
              >
                {{ type }}
              </b-form-radio>
            </b-form-group>
          </td>
          <td style="width:30%; text-align: left">
            <b-form-group>
              <b-form-radio
                v-for="(uom, typeIndex) in control.unitOfMeasures"
                :key="typeIndex"
                v-model="control.unitOfMeasure"
                :name="`uom${control.name}`"
                :value="uom"
              >
                {{ uom }}
              </b-form-radio>
            </b-form-group>
          </td>
          <td style="width:30%" v-if="control.type">
            <b-input-group
              :append="control.type == 'Cost Plus %' ? '%' : null"
              :prepend="
                control.type.includes('Dollar Amount', 'Hours') ? '$' : null
              "
            >
              <b-form-input
                style="text-align:center"
                :disabled="!control.active"
                :class="!control.active ? 'disabled-textbox' : ''"
                :placeholder="control.type"
                v-model="control.value"
                :state="control.value ? validateEntry(control.value) : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback">
                Input must be a number
              </b-form-invalid-feedback>
            </b-input-group>
            <b-form-group
              class="mt-2"
              v-if="
                controlsInitial &&
                  controlsInitial[index].value &&
                  control.value !== controlsInitial[index].value
              "
              label="Reason for Budget Revision"
              label-for="revisionDescription"
              :invalid-feedback="invalidFeedbackBudget"
              :state="
                categoryRevisions[index] && categoryRevisions[index] !== ''
                  ? true
                  : null
              "
            >
              <b-form-input
                class="mt-2"
                id="revisionDescription"
                v-model="categoryRevisions[index]"
                :state="
                  categoryRevisions[index] && categoryRevisions[index] !== ''
                    ? true
                    : null
                "
              ></b-form-input>
            </b-form-group>
          </td>
        </tr>
      </tbody>
    </table>
    <table
      v-if="
        childCategoryBudgetsEnabled &&
          controls.procurements &&
          controls.procurements.active
      "
      class="table table-centered table-nowrap"
    >
      <thead class="thead-light" style="text-align:center">
        <tr>
          <th style="width: 20px;">Enabled</th>
          <th>Name</th>
          <th>Type</th>
          <th>Unit of Measure</th>
          <th>Budget</th>
        </tr>
      </thead>
      <tbody style="text-align:center">
        <tr v-for="(control, index) in procurementControls" :key="control.name">
          <td>
            <div
              v-if="control.type"
              :id="`checkbox-${index}`"
              style="display: inline-block;"
            >
              <b-form-checkbox v-model="control.active"> </b-form-checkbox>
            </div>
          </td>
          <td>
            <a class="text-body font-weight-bold no-pointer">{{
              control.name
            }}</a>
          </td>
          <td style="width:30%; text-align: left">
            <b-form-group>
              <b-form-radio
                v-for="(type, typeIndex) in control.types"
                :key="typeIndex"
                v-model="control.type"
                :name="control.name"
                :value="type"
              >
                {{ type }}
              </b-form-radio>
            </b-form-group>
          </td>
          <td style="width:30%; text-align: left">
            <b-form-group>
              <b-form-radio
                v-for="(uom, typeIndex) in control.unitOfMeasures"
                :key="typeIndex"
                v-model="control.unitOfMeasure"
                :name="`uom${control.name}`"
                :value="uom"
              >
                {{ uom }}
              </b-form-radio>
            </b-form-group>
          </td>
          <td style="width:30%" v-if="control.type">
            <b-input-group
              :append="control.type == 'Cost Plus %' ? '%' : null"
              :prepend="
                control.type.includes('Dollar Amount', 'Hours') ? '$' : null
              "
            >
              <b-form-input
                style="text-align:center"
                :disabled="!control.active"
                :class="!control.active ? 'disabled-textbox' : ''"
                :placeholder="control.type"
                v-model="control.value"
                :state="control.value ? validateEntry(control.value) : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback">
                Input must be a number
              </b-form-invalid-feedback>
            </b-input-group>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import appConfig from '@/app.config';
import Switches from 'vue-switches';

export default {
  page: {
    title: 'Job Budgets',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Switches,
  },
  props: {
    controls: Object,
    procurementControls: Object,
    categoryBudgetsEnabled: Boolean,
    jobBudget: String,
  },
  data() {
    return {
      title: 'Job Budgets',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'job budgets',
          href: '/production/components/jobs/jobBudgets',
          active: true,
        },
      ],
      childCategoryBudgetsEnabled: this.categoryBudgetsEnabled,
      childCategoryBudgetsEnabledInitial: this.categoryBudgetsEnabled,
      jobBudgetValid: false,
      childJobBudget: this.jobBudget,
      childJobBudgetInitial: this.jobBudget,
      revisionDescription: null,
      controlsInitial: JSON.parse(JSON.stringify(this.controls)),
      categoryRevisions: {
        labour: null,
        procurements: null,
        products: null,
      },
    };
  },
  computed: {
    invalidFeedbackBudget() {
      if (
        this.childJobBudget === null ||
        this.childJobBudget === undefined ||
        this.childJobBudget.trim() === ''
      ) {
        this.changeValidationValue('jobBudget', false);
        return 'Please enter a valid dollar amount for the budget.';
      } else if (isNaN(this.childJobBudget.trim())) {
        this.changeValidationValue('jobBudget', false);
        return 'The budget must be a number';
      } else {
        this.changeValidationValue('jobBudget', true);
      }
      return 'Please enter a valid dollar amount for the budget.';
    },
  },
  methods: {
    validateEntry(entry) {
      //check that value inputted is a number
      if (!isNaN(Number(entry)) && entry.trim() !== '') {
        return true;
      } else {
        return false;
      }
    },
    changeValidationValue(field, value) {
      if (field === 'jobBudget') {
        this.jobBudgetValid = value;
      }
    },
    currencyAutoFormatter($event, value) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (
        (keyCode < 48 || keyCode > 57) &&
        (keyCode !== 46 || value.indexOf('.') != -1)
      ) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (
        value != null &&
        value.indexOf('.') > -1 &&
        value.split('.')[1].length > 1
      ) {
        $event.preventDefault();
      }
    },
    jobBudgetUpdated(value) {
      this.$emit('jobBudgetUpdated', value);
    },
  },
  mounted: function() {},
};
</script>
